import script from "./WCConfiguredProductSectionRows.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCConfiguredProductSectionRows.vue?vue&type=script&setup=true&lang=ts"

import "./WCConfiguredProductSectionRows.vue?vue&type=style&index=0&id=4e98ab65&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e98ab65"]])

export default __exports__